import { Component, Vue } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import './detail-message-modal.scss';

@Component({})
export default class DetailMessageModal extends Vue {
  @Prop() title!: string;
  @Prop() errorMsg!: string;
  @Prop() idModal!: string;

  private closeModal(): void {
    this.$bvModal.hide(this.idModal);
  }

  render() {
    return (
      <div>
        <b-modal
          id={this.idModal}
          centered
          size="lg"
          hide-footer
          hide-header
          onHide={() => {
            this.closeModal();
          }}
        >
          <template class="modal-header border-bottom-0 d-flex flex-column align-items-center justify-content-center">
            <h5 class="font-weight-bold">{this.title}</h5>
            <span
              class="icon icon-close-modal-svg text-font cursor-pointer"
              onClick={() => {
                this.closeModal();
              }}
            ></span>
          </template>
          <b-container fluid class="pt-1">
            <p class="max-height-content">{this.errorMsg}</p>
          </b-container>
        </b-modal>
      </div>
    );
  }
}
